<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('service-banner-table')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Banner</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          placeholder="Heading"
          :rules="{ required: true }"
          v-model="service_data.heading"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="Description"
          :rules="{ required: true }"
          placeholder="Description"
          v-model="service_data.discription"
        >
        </base-input>

        <base-input
          alternative
          class="mb-3"
          name="Redirect To"
          :rules="{ required: true }"
          placeholder="Redirect To"
          v-model="service_data.redirectTo"
        >
        </base-input>

        <base-input
          alternative
          class="mb-3"
          name="Button Name"
          :rules="{ required: true }"
          placeholder="Button Name"
          v-model="service_data.buttonName"
        >
        </base-input>

        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div v-if="image">
          <p class="mb-2 text-danger">Image Preview</p>

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
          <img v-if="image" :src="image" ref="cover" />
        </div>

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            alt="uploaded-image"
            :src="$imageURL + '/' + service_data.image"
          />
        </div>
        <!-- <quill-editor
          v-model="service_data.discription"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      icon: "",
      coverImage: "",
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      pageData: {},
      service_data: {},
      imageErr: false,
      msg: {},
    };
  },
  computed: {
    ...mapState("services", {
      selectbanner: "selectbanner",
    }),
  },
  watch: {
    pageData(val) {
      this.service_data = { ...val };
      // console.log(this.service_data);
    },
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;

      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.service_data._id);
      data.append("heading", this.service_data.heading);
      data.append("image", this.coverImage);
      data.append("discription", this.service_data.discription);
      data.append("redirectTo", this.service_data.redirectTo);
      data.append("buttonName", this.service_data.buttonName);
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "services/editbanner",
          data
        );
        // if (editData.code == 200) {
        this.$router.push({ name: "service-banner-table" });
        this.$swal.fire({
          text: "Your banner has been successfully edited",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        // }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectbanner;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
